import React, {useEffect, useState} from 'react';
import localStrings from "../../../localStrings";
import GeneralResult from "../../../components/CrudFrom/GeneralResult";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import {
  bulkDeleteProductUserMutation,
  deleteProductUserCache,
} from "../../../gql/productUserGql";
import {Button, Chip, SvgIcon, TableCell} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import {
  addDataTempBrandUserToCache,
  bulkDeleteTempBrandUserMutation,
  createTempBrandUserMutation,
  deleteTempBrandUserCache,
} from "../../../gql/tempBrandUserGql";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import {useDialog} from "../../../hooks/use-dialog";
import AddUserDialog from "./AddUserDialog";
import {uuid} from "uuidv4";
import cloneDeep from "clone-deep";
import enqueueSnackbarWithSound from "../../../utils/SnackBarWithSound";
import toast from "react-hot-toast";
import {collection, getFirestore} from "firebase/firestore";
import {
  PRODUCT_USER_COLLECTION,
  TEMP_BRAND_USER_COLLECTION
} from "../../../../src/utils/constants";
import {useCollectionData} from "react-firebase-hooks/firestore";

function UserList({}) {
  const inviteUserDialog = useDialog();
  const {currentBrand, userInDb, user} = useAuth();

  const db = getFirestore();

  const refCollectionUsers =  collection(db, PRODUCT_USER_COLLECTION)
    //hxRHr6ESnqW5OH6O9tEI

  const [productUsers, productUsersLoading, productUsersHealthError] = useCollectionData(
    refCollectionUsers
    , {
      snapshotListenOptions: { includeMetadataChanges: true },
    });

  const refCollectionTempUsers =  collection(db, TEMP_BRAND_USER_COLLECTION);

  const [tempProductUsers, tempProductUsersLoading, tempProductUsersError] = useCollectionData(
    refCollectionTempUsers
    , {
      snapshotListenOptions: { includeMetadataChanges: true },
    });

  function getUsers() {
    let allUsers = [];
    let productUsersClone = cloneDeep(productUsers || []);
    allUsers = allUsers.concat(productUsersClone.filter(u =>
      u.brandId == currentBrand().id && u.id != userInDb.id));

    let tempUsersClone = cloneDeep(tempProductUsers || []);
    tempUsersClone.forEach(tu => tu.tempUser = true);

    allUsers = allUsers.concat(tempUsersClone.filter(u => u.brandId == currentBrand().id));
    return allUsers;
  }

  const deleteUsers = async (ids, size) => {
    const userId = ids[0];
    const tempUser = getUsers().find(u => u.id === userId && u.tempUser);
    if (tempUser) {
      await executeMutationUtil(bulkDeleteTempBrandUserMutation([tempUser.id]));
      await deleteTempBrandUserCache(currentBrand().id, [tempUser.id]);
      return;
    }
    else {
      await executeMutationUtil(bulkDeleteProductUserMutation([userId]));
      await deleteProductUserCache(currentBrand().id, [userId]);
    }
  }

  const getTableCell = (item) => {
    return(
      <>
        <TableCell>
          {item.displayName}
        </TableCell>
        <TableCell>
          {item.email}
        </TableCell>
        <TableCell>
          {item.tempUser ?
            <Chip label={localStrings.pendingConfirmationUser} />
            :
            <Chip label={localStrings.confirmedUser} />
          }
        </TableCell>

      </>
    )
  }

  const getTableCellColumn = () => {
    return(
      <React.Fragment>
        <TableCell>
          {localStrings.name}
        </TableCell>
        <TableCell>
          {localStrings.email}
        </TableCell>
        <TableCell>
          {localStrings.status}
        </TableCell>
        <TableCell>
          {localStrings.actions}
        </TableCell>
      </React.Fragment>
    )
  }

  function inviteUserShoDialog() {
    inviteUserDialog.handleOpen();
  }

  async function inviteUser(userEmail, role) {
    const res = await executeMutationUtil(createTempBrandUserMutation({
      id: uuid(),
      email: userEmail,
      brandId: currentBrand().id,
      role: role
    }));
    await addDataTempBrandUserToCache(currentBrand().id, [res.data?.addTempBrandUser]);

    enqueueSnackbarWithSound(toast, null, null,
      localStrings.formatString(localStrings.notif.userPendingCreated));
  }

  return (
    <>
      <GeneralResult
        getPathToData={(result) => result}
        getTableCell={getTableCell}
        getTableCellColumn={getTableCellColumn}
        disableBulkEdit
        deleteDialogText={localStrings.confirmMessage.deleteUser}
        deleteItemsFunction={userInDb?.mainUser ? deleteUsers : null}
        deleteItemNotifMessage={localStrings.notif.userDeleted}
        searchProperties={['name']}
        itemsSource={getUsers()}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={inviteUserShoDialog}
          startIcon={(
            <SvgIcon>
              <PlusIcon />
            </SvgIcon>
          )}
        >
          {localStrings.inviteUser}
        </Button>
      </GeneralResult>

      <AddUserDialog
        onClose={inviteUserDialog.handleClose}
        open={inviteUserDialog.open}
        selectCallBack={(userEmail, role) =>
          inviteUser(userEmail, role)
        }
      />
    </>
  );
}

export default UserList;
